export default function Compensation({ review, details = false }) {
  const pay = review?.current === false ? null : review?.compensation;
  if (!pay || !["published", "estimated"].includes(pay.kind)) return <span>{review?.payment || "Payment unknown"}</span>;
  const estimated = pay.kind === "estimated";
  const stop = (event) => event.stopPropagation();
  return (
    <span className="block" data-testid="compensation" data-compensation-kind={pay.kind}>
      <span className={estimated ? "text-yellow-400 font-medium" : "text-foreground"}>
        {estimated ? "Estimated Range: " : "Published Range: "}{pay.text}
      </span>
      {estimated && <span className="block text-muted-foreground text-xs mt-1">Employer amount undisclosed · {pay.basis}</span>}
      <span className="block text-xs mt-1">
        {details ? <a href={pay.source_url} target="_blank" rel="noreferrer" onClick={stop} className="underline text-primary">{estimated ? "Range evidence" : "Employer pay source"}</a> : <span className="text-muted-foreground">Source in job details</span>}
        <span className="text-muted-foreground"> · Checked {pay.checked_at}</span>
      </span>
      {details && <>
        <span className="block text-xs text-muted-foreground mt-2">{pay.limitations}</span>
        {(pay.additional_sources || []).map((source) => <a key={source.url} href={source.url} target="_blank" rel="noreferrer" onClick={stop} className="block text-xs underline text-primary mt-1">{source.label}</a>)}
      </>}
    </span>
  );
}
